// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../node_modules/less-loader/dist/cjs.js!../../../shared/CampaignPanel/panel.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IN5IfSJZGvU4QiMfC07z {
  --campaign-panel-center-top: 284px;
}
.IN5IfSJZGvU4QiMfC07z[data-has-many='true'] {
  --campaign-panel-center-top: 282px;
  --campaign-panel-title-margin-bottom: 17px;
}
.h5N7SKrMTaRhjhN3nFzZ {
  /* Never wider than the panel minus an 8px gutter per side. */
  left: 8px;
  right: 8px;
  max-width: calc(100% - 16px);
}
.qtPzFtSp_Iavs0ooC5yN {
}
.djpzpaYPDon81CzGQen5 {
}
@media (min-width: 1025px) and (orientation: landscape) {
  .djpzpaYPDon81CzGQen5[data-has-many='true'] {
    top: 350px;
  }
}
.QzEYYrd2jNqMncsRFo98 {
}
@media (min-width: 1025px) and (orientation: landscape) {
  .QzEYYrd2jNqMncsRFo98 {
    margin-bottom: 11px;
  }
}
.jBKqIRbYLwV3zQO6n_VU {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--campaign-panel-title-margin-bottom, 16px);
}
.h5N7SKrMTaRhjhN3nFzZ[data-variant='panel'] .jBKqIRbYLwV3zQO6n_VU .qtPzFtSp_Iavs0ooC5yN {
  margin-bottom: 0;
  font-size: 26px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .IN5IfSJZGvU4QiMfC07z {
    --campaign-panel-center-top: 172px;
  }
  .IN5IfSJZGvU4QiMfC07z[data-has-many='true'] {
    --campaign-panel-center-top: 180px;
    --campaign-panel-title-margin-bottom: 12px;
  }
  .jBKqIRbYLwV3zQO6n_VU {
    margin-bottom: var(--campaign-panel-title-margin-bottom, 13px);
  }
  .h5N7SKrMTaRhjhN3nFzZ[data-variant='panel'] .jBKqIRbYLwV3zQO6n_VU .qtPzFtSp_Iavs0ooC5yN {
    font-size: 20px;
  }
  /* TODO - Figma Rebate - remove it when making the games reposition improvement */
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .IN5IfSJZGvU4QiMfC07z[data-has-many='true'] {
    height: 273px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .IN5IfSJZGvU4QiMfC07z[data-has-many='true'] {
    height: 273px;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .djpzpaYPDon81CzGQen5[data-has-many='true'] {
    top: 231px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .djpzpaYPDon81CzGQen5[data-has-many='true'] {
    top: 231px;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .IN5IfSJZGvU4QiMfC07z {
    --campaign-panel-center-top: 182px;
  }
  .IN5IfSJZGvU4QiMfC07z[data-has-many='true'] {
    --campaign-panel-center-top: 185px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .IN5IfSJZGvU4QiMfC07z {
    --campaign-panel-center-top: 182px;
  }
  .IN5IfSJZGvU4QiMfC07z[data-has-many='true'] {
    --campaign-panel-center-top: 185px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/RebatePanel/RebatePanel.module.css"],"names":[],"mappings":"AAAA;EAEE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EAEE,6DAA6D;EAC7D,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;AACA;AAEA;AACA;AAEA;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;AAEA;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8DAA8D;AAChE;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;EACA;IACE,8DAA8D;EAChE;EACA;IACE,eAAe;EACjB;EACA,iFAAiF;AACnF;AACA;AAAA;EACE;IACE,aAAa;EACf;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,aAAa;EACf;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;AAAA;AAAA;AAAA","sourcesContent":[".panelContainer {\n  composes: panelContainer from '../../../shared/CampaignPanel/panel.module.css';\n  --campaign-panel-center-top: 284px;\n}\n.panelContainer[data-has-many='true'] {\n  --campaign-panel-center-top: 282px;\n  --campaign-panel-title-margin-bottom: 17px;\n}\n.centerInfoWrapper {\n  composes: centerInfoWrapper from '../../../shared/CampaignPanel/panel.module.css';\n  /* Never wider than the panel minus an 8px gutter per side. */\n  left: 8px;\n  right: 8px;\n  max-width: calc(100% - 16px);\n}\n.campaignInfoTitle {\n  composes: campaignInfoTitle from '../../../shared/CampaignPanel/panel.module.css';\n}\n.periodWrapper {\n  composes: periodWrapper from '../../../shared/CampaignPanel/panel.module.css';\n}\n@media (--campaign-desktop) {\n  .periodWrapper[data-has-many='true'] {\n    top: 350px;\n  }\n}\n.separator {\n  composes: separator from '../../../shared/CampaignPanel/panel.module.css';\n}\n@media (--campaign-desktop) {\n  .separator {\n    margin-bottom: 11px;\n  }\n}\n.mainTitleWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--campaign-panel-title-margin-bottom, 16px);\n}\n.centerInfoWrapper[data-variant='panel'] .mainTitleWrapper .campaignInfoTitle {\n  margin-bottom: 0;\n  font-size: 26px;\n}\n@media (--campaign-mobile) {\n  .panelContainer {\n    --campaign-panel-center-top: 172px;\n  }\n  .panelContainer[data-has-many='true'] {\n    --campaign-panel-center-top: 180px;\n    --campaign-panel-title-margin-bottom: 12px;\n  }\n  .mainTitleWrapper {\n    margin-bottom: var(--campaign-panel-title-margin-bottom, 13px);\n  }\n  .centerInfoWrapper[data-variant='panel'] .mainTitleWrapper .campaignInfoTitle {\n    font-size: 20px;\n  }\n  /* TODO - Figma Rebate - remove it when making the games reposition improvement */\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .panelContainer[data-has-many='true'] {\n    height: 273px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .periodWrapper[data-has-many='true'] {\n    top: 231px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .panelContainer {\n    --campaign-panel-center-top: 182px;\n  }\n  .panelContainer[data-has-many='true'] {\n    --campaign-panel-center-top: 185px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelContainer": `IN5IfSJZGvU4QiMfC07z ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panelContainer"]}`,
	"centerInfoWrapper": `h5N7SKrMTaRhjhN3nFzZ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["centerInfoWrapper"]}`,
	"campaignInfoTitle": `qtPzFtSp_Iavs0ooC5yN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["campaignInfoTitle"]}`,
	"periodWrapper": `djpzpaYPDon81CzGQen5 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["periodWrapper"]}`,
	"separator": `QzEYYrd2jNqMncsRFo98 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["separator"]}`,
	"mainTitleWrapper": `jBKqIRbYLwV3zQO6n_VU`
};
export default ___CSS_LOADER_EXPORT___;
